import { Link } from "react-router-dom";
import { Icon } from "semantic-ui-react";

import { useCan } from "components";
import { ACL_ACTIVITIES, ACL_RESOURCES } from "models";
import { useManufacturerNotificationCountQuery } from "modules/ManufacturerDashboard/hooks";
import { PATHS } from "router/paths";

export const ManufacturerNotifications = () => {
  const { manufacturerNotificationCount } = useManufacturerNotificationCountQuery();

  const canUpdateManufacturerRequests = useCan(ACL_ACTIVITIES.Update, ACL_RESOURCES.ManufacturerRequest);
  if (!canUpdateManufacturerRequests || !manufacturerNotificationCount || manufacturerNotificationCount < 1) return null;

  return (
    <Link to={PATHS.MANUFACTURER_DASHBOARD} className="notifications-wrapper">
      <Icon className="factory" />
      {manufacturerNotificationCount ? <span className="notifications-count">{manufacturerNotificationCount}</span> : null}
    </Link>
  );
};
